
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/billing/faqs",
      function () {
        return require("private-next-pages/support/billing/faqs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/billing/faqs"])
      });
    }
  